<template>
  <header class="container m-header py-3 py-md-4">
    <router-link to="/">
      <img src="@/assets/images/logo.png" class="logo mr-2 mr-md-4" alt />
    </router-link>
    <div class="right">
      <div class="top mb-2">
        <div class="vendor-block mr-auto mb-2 mb-md-0">
          <img src="@/assets/images/icon_auth_vendor.png" class="icon" alt="" />
          <span class="text">认证供应商: </span>
          <span class="num">12201家</span>
        </div>
        <div class="other mb-2">
          <button class="other-button publish" @click.stop="showPublishModal">
            免费发布项目
          </button>
          <button class="other-button auth" @click.stop="showAuthModal">
            供应商认证
          </button>
        </div>
        <div class="auth">
          <router-link class="item" to="/login">登录</router-link>
          <span class="line">|</span>
          <router-link class="item" to="/registe">注册</router-link>
        </div>
      </div>
      <div class="bottom">
        <div class="search-block mr-auto mb-2 mb-md-0">
          <input type="text" placeholder="请输入项目名称" v-model="keyword" />
          <button class="search-button" @click.stop.prevent="search">
            搜索
          </button>
        </div>
        <div class="tab-list">
          <router-link
            class="tab"
            v-for="(tab, index) in tabList"
            active-class="active"
            :exact="index === 0"
            :key="index"
            :to="tab.to"
            >{{ tab.name }}</router-link
          >
        </div>
      </div>
    </div>
    <publish-modal ref="publishModal"></publish-modal>
    <auth-modal ref="authModal"></auth-modal>
  </header>
</template>
<style lang="scss" scoped>
.m-header {
  // max-height: 40rem;
  // height: 15rem;
  // min-height: 10rem;
  display: flex;
  align-items: center;
  .logo {
    // margin-right: 2rem;
  }
  .right {
    // height: 5.94rem;
    // height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .top {
      display: flex;
      flex-wrap: wrap;
      .vendor-block {
        .icon {
          margin-right: 0.5rem;
        }
        .text {
          font-size: 1rem;
          color: #333;
        }
        .num {
          font-size: 1rem;
          color: $acentColor;
        }
      }
      .other {
        margin-right: 1.8rem;
        display: flex;
        flex-wrap: no-wrap;
        .other-button {
          display: inline-block;
          color: white;
          font-size: 1rem;
          text-align: center;
          line-height: 1.69rem;
          height: 1.69rem;
          width: 7.63rem;
          border: none;
          outline: none;
          &:hover {
            text-decoration: none;
          }
          &.publish {
            background-color: #ef5d0e;
            margin-right: 0.94rem;
          }
          &.auth {
            background-color: #efa517;
          }
        }
      }
      .auth {
        .item {
          font-size: 0.88rem;
          color: #666;
        }
        .line {
          color: #666;
          margin: 0 0.4rem;
        }
      }
    }
    .bottom {
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      .search-block {
        white-space: nowrap;
        max-height: 2.5rem;
        height: 2rem;

        input[type='text'] {
          max-width: 20rem;
          width: 65%;
          height: 100%;
          background-image: url(../assets/images/icon_search.png);
          background-position: 1rem center;
          background-repeat: no-repeat;
          padding-left: 3rem;
          outline: none;
          border: solid 0.06rem #e5e5e5;
          &::placeholder {
            font-size: 1.13rem;
            color: #cccccc;
          }
        }
        .search-button {
          background-color: $acentColor;
          color: white;
          font-size: 1.13rem;
          outline: none;
          border: none;
          height: 100%;
          width: 6rem;
        }
      }
      .tab-list {
        max-width: 26.5rem;
        width: 100%;
        display: flex;
        justify-content: space-between;
        height: 1.5rem;
        .tab {
          color: #333;
          font-size: 1rem;
          white-space: nowrap;
          &:hover {
            text-decoration: none;
          }
          &.active {
            color: $acentColor;
            border-bottom: 0.13rem solid $acentColor;
          }
        }
      }
    }
  }
}
</style>
<script>
import PublishModal from '@/components/PublishModal';
import AuthModal from '@/components/AuthModal';
export default {
  data() {
    return {
      tabList: [
        { name: '首页', to: '/' },
        { name: '交易中心', to: '/market' },
        { name: '认证供应商', to: '/vendor' },
        { name: '关于我们', to: '/about' }
      ],
      keyword: ''
    };
  },
  methods: {
    showPublishModal() {
      this.$refs.publishModal.show();
    },
    showAuthModal() {
      this.$refs.authModal.show();
    },
    search() {
      if (this.keyword) {
        this.$router.push({
          path: '/market',
          query: { projectName: this.keyword }
        });
      } else {
        window.alert('搜索词不能为空');
      }
    }
  },
  components: {
    PublishModal,
    AuthModal
  }
};
</script>
